import { FIELD_PATHS } from '@funnels/constants';
import { BrokerInterviewsGuarantorEntityIndex } from '@funnels/types';
import { validateNotFutureDate } from '@funnels/utils';

import { FunnelGrid, FunnelGridUnit } from '../../../Common';
import { DatePickerInputField } from '../../../Fields';

export const InterviewDate = ({ brokerInterviewsGuarantorIndex }: BrokerInterviewsGuarantorEntityIndex) => {
  return (
    <FunnelGrid mt="md" mb="lg">
      <FunnelGridUnit size={1 / 2}>On what date did I interview the guarantor?</FunnelGridUnit>
      <FunnelGridUnit size={{ xs: 1 / 2, md: 1 / 2, lg: 1 / 3, xl: 1 / 4 }}>
        <DatePickerInputField
          name={FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_INTERVIEW_DATE(brokerInterviewsGuarantorIndex)}
          label="Interview date"
          validate={validateNotFutureDate(undefined, true)}
          hasDayField
          isOptional
        />
      </FunnelGridUnit>
    </FunnelGrid>
  );
};
